import reactLogo from '../logo.svg'
export const ReactLogo = () => {
  return (
    <div className="logo">
      <img className="rotating"src={reactLogo} alt="React Logo"
        style={{
            position:'fixed',
            bottom:'20px',
            right:'20px',
            width:'90px'
        }}
    />
    </div>
    
  )
}
